export default class State {
  online = true;
}
